export default function SectionContact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[680px] mx-auto text-center">
          <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
            Contact
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 mb-4">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            你有猛料要爆？有独家线索要提供？还是想加入每日大赛mrds的编辑团队？
            无论你是圈内人士还是热心吃瓜群众，我们都欢迎你的来稿和爆料。
          </p>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left">
              <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 shrink-0">
                <i className="ri-mail-send-line text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">投稿 / 爆料入口</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  请将你的爆料内容发送至投稿邮箱，我们会在24小时内审核回复。优质爆料一经采用将获得首页推荐位展示。
                </p>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap">
                  <i className="ri-mail-line"></i>
                  <span>tips@mrdsdaily.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}